import React from "react";

export default function KeyIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 36 36" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <path d="m27.65 33.69-4-4a1.07 1.07 0 0 1 -.29-.54l-.61-3.08-3.08-.61a1.07 1.07 0 0 1 -.54-.29l-2.57-2.57a10.55 10.55 0 0 1 -3.9.74 10.67 10.67 0 1 1 10.67-10.67 10.55 10.55 0 0 1 -.74 3.9l11.1 11.09a1.07 1.07 0 0 1 .29 1l-.75 3.77a1.07 1.07 0 0 1 -.84.84l-3.77.73a1.17 1.17 0 0 1 -.97-.31zm-2.27-5.29 3.38 3.38 2.51-.5.5-2.51-11.2-11.2a1.07 1.07 0 0 1 -.21-1.22 8.45 8.45 0 0 0 .83-3.68 8.53 8.53 0 1 0 -8.53 8.53 8.45 8.45 0 0 0 3.68-.83 1.06 1.06 0 0 1 1.22.21l2.84 2.84 3.46.69a1.07 1.07 0 0 1 .84.84z" fill={filteredStyles.fill}/>
      <path d="m11.07 14.8a3.73 3.73 0 1 1 3.73-3.73 3.74 3.74 0 0 1 -3.73 3.73zm0-5.33a1.6 1.6 0 1 0 1.6 1.6 1.6 1.6 0 0 0 -1.6-1.6z" fill={filteredStyles.fill}/>
    </svg>
  );
}
